import { AppConfigService } from 'services/app-config.service';

export function initializeApp(appConfigService: AppConfigService): () => Promise<any> {
  return (): Promise<any> => {
    return appConfigService.load();
  };
}
